import { Group } from '@mantine/core';
import { IconButton, Text } from '@repo/foundations';
import { getCountDisplay } from '../../../PoliciesPage/utils';

interface ViolationTableFooterProps {
	isLoading: boolean;
	page: number;
	totalCount: number;
	hasPreviousPage: boolean;
	hasNextPage: boolean;
	onPageChange?: (page: number) => void;
}

export function ViolationTableFooter({
	isLoading,
	page,
	totalCount,
	hasPreviousPage,
	hasNextPage,
	onPageChange,
}: ViolationTableFooterProps) {
	return (
		<Group position="apart" p="xs" noWrap>
			<Text color="text/secondary/default" size="xs">
				{isLoading
					? 'Loading...'
					: `${(page - 1) * 50 + 1}-${Math.min(page * 50, totalCount)} of ${getCountDisplay(totalCount)} resources`}
			</Text>
			<Group spacing="xs">
				<IconButton
					disabled={!hasPreviousPage}
					variant="tertiary"
					iconName="chevronLeft"
					onClick={() => onPageChange?.(page - 1)}
				/>
				<IconButton
					disabled={!hasNextPage}
					variant="tertiary"
					iconName="chevronRight"
					onClick={() => onPageChange?.(page + 1)}
				/>
			</Group>
		</Group>
	);
}
